<template>
  <base-page-layout title="Configurações mobile">
    <v-tabs v-model="tab" grow class="mb-5">
      <v-tab to="/mobile/configuracoes"> Banner </v-tab>
    </v-tabs>
    <router-view />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'

export default {
  components: {
    BasePageLayout,
  },
  data: () => ({
    tab: 0,
  }),
}
</script>
